"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SingpassEvents;
(function (SingpassEvents) {
    SingpassEvents["SINGPASS_AUTHORIZATION"] = "singpass_authorization";
})(SingpassEvents = exports.SingpassEvents || (exports.SingpassEvents = {}));
